export class AARPAnalytics {
  public static virtualPageLoad() {
    window.dispatchEvent(new CustomEvent("virtual_page_load"));
  }

  //AARP Analytics
  public static attr1Get(slug?: string) {
    const attr = { "data-categoryid": "AARP Games" };
    if (!slug) return attr;

    return slug in ["pattern-match", "double-up"] ? attr : null;
  }

  public static attr2Get(slug: string) {
    switch (slug) {
      case "double-up":
        return {
          "data-formelementid": "GAMES-BTN-CLK-MEMBERSHIP-SS-TILE-DOUBLE_UP",
        };

      case "pattern-match":
        return {
          "data-formelementid":
            "GAMES-BTN-CLK-MEMBERSHIP-SS-TILE-PATTERN_MATCH",
        };

      default:
        return null;
    }
  }

  public static attrSaveScoreGameEnd() {
    return {
      "data-formelementid": "GAMES-BTN-CLK-MEMBERSHIP-LOGIN-SSIG_MODAL",
    };
  }

  public static attrJoin() {
    return { "data-formelementid": "GAMES-BTN-CLK-MEMBERSHIP-JOIN-MOIG_MODAL" };
  }
}
